__turbopack_context__.v({
  "crikey": "404-module-scss-module__dqkhia__crikey",
  "four04": "404-module-scss-module__dqkhia__four04",
  "link": "404-module-scss-module__dqkhia__link",
  "title": "404-module-scss-module__dqkhia__title",
});
